import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const socials = [
  { label: "GitHub", href: "https://github.com/RolandWHK" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/koffi-roland-wotobe-06325925a" },
  { label: "Email", href: "mailto:wotobekoffiroland@gmail.com" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E5DF] bg-[#0A0A0A] text-[#F9F9F7]">
      <div className="mx-auto max-w-[1600px] px-6 py-20 md:px-12 md:py-28">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div>
            <span className="font-mono text-[0.7rem] uppercase tracking-[0.22em] text-[#D1D1C7]">
              Available for apprenticeship
            </span>
            <a
              href="mailto:wotobekoffiroland@gmail.com"
              data-testid="footer-email"
              className="group mt-6 block font-display text-5xl font-medium leading-none tracking-tight md:text-8xl"
            >
              <span className="bg-gradient-to-r from-[#F9F9F7] to-[#F9F9F7] bg-[length:0%_1px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 group-hover:bg-[length:100%_1px]">
                Let&apos;s work together
              </span>
            </a>
          </div>

          <nav className="flex flex-col gap-4">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.label === "Email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                data-testid={`footer-link-${s.label.toLowerCase()}`}
                className="group inline-flex items-center gap-2 font-mono text-sm uppercase tracking-[0.14em] text-[#D1D1C7] transition-colors duration-300 hover:text-[#F9F9F7]"
              >
                {s.label}
                <ArrowUpRight strokeWidth={1.4} className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-[#5C5C5C]">
            © {new Date().getFullYear()} WOTOBE Koffi Roland
          </p>
          <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-[#5C5C5C]">
            Data Scientist — Machine Learning
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
